import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';

import {ManageOrganisation} from '@store/common/organisation.model';
import {supplierDetailsStore} from '@store/suppliers/details/supplier-details.store';

export const getSupplierDetailsDataSource = createRequestDataSource({
  store: supplierDetailsStore,
  data$: () => supplierDetailsStore.pipe(select((state) => state as ManageOrganisation)),
  requestKey: 'getSupplierDetails',
  dataKey: 'headOffice',
});